import { SummaryCard } from '../../../types';

export const turkceCards: SummaryCard[] = [
  // TÜRKÇE DERSİ - 17 KONU
  {
    id: 'tr-001',
    title: 'Sözcükte Anlam',
    subject: 'turkce',
    topic: 'Anlam Bilgisi',
    content: `# Sözcükte Anlam

## Gerçek Anlam (Temel Anlam)
Sözcüklerin ilk ve asıl anlamlarıdır. Sözlükte yer alan temel anlamdır.
**Örnek**: "Aslan" sözcüğünün gerçek anlamı büyük yırtıcı hayvan.

## Yan Anlam (Mecaz Anlam)
Sözcüklerin gerçek anlamlarından başka kazandıkları anlamlardır.
**Örnek**: "Aslan gibi adam" - cesur, güçlü adam anlamında.

## Eş Anlamlı Sözcükler
Aynı veya yakın anlam taşıyan sözcüklerdir.
**Örnekler**: güzel-hoş, büyük-iri, sevmek-aşık olmak

## Zıt Anlamlı Sözcükler
Karşıt anlam taşıyan sözcüklerdir.
**Örnekler**: büyük-küçük, açık-koyu, gelmek-gitmek

## Eş Sesli Sözcükler
Aynı sesletimle söylenen ama farklı anlam taşıyan sözcüklerdir.
**Örnekler**: yüz (sayı) - yüz (organ), aç (tok değil) - aç (kapıyı aç)`,
    keyPoints: [
      'Her sözcüğün bir gerçek (temel) anlamı vardır',
      'Yan anlam, sözcüklerin mecazi kullanımlarıdır',
      'Eş anlamlı sözcükler benzer anlamları ifade eder',
      'Zıt anlamlı sözcükler karşıt kavramları belirtir',
      'Eş sesli sözcükler yazılışları farklı olabilir'
    ],
    examples: [
      'Gerçek anlam: Kar yağıyor. (buzlu yağmur)',
      'Yan anlam: Saçları kar gibi beyaz. (çok beyaz)',
      'Eş anlam: hızlı = süratli',
      'Zıt anlam: sıcak ≠ soğuk'
    ],
    difficulty: 'easy',
    estimatedReadTime: 6,
    tags: ['anlam', 'sözcük', 'mecaz', 'eş anlam', 'zıt anlam'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-002',
    title: 'Cümlede Anlam',
    subject: 'turkce',
    topic: 'Anlam Bilgisi',
    content: `# Cümlede Anlam

## Düz Anlam
Cümlenin kelime anlamından çıkan doğrudan anlamdır.
**Örnek**: "Bahçede çiçekler açtı." - Çiçekler gerçekten açıldı.

## Mecaz Anlam
Cümlenin asıl anlamından farklı, kapalı bir anlamdır.
**Örnek**: "Yüzü güldü." - Mutlu oldu anlamında.

## Gerçek Anlam - Mecaz Anlam Farkı
- **Gerçek**: "Kalbi duracak gibi oldu." (Kalp gerçekten duracak)
- **Mecaz**: "Kalbi duracak gibi oldu." (Çok korktu, heyecanlandı)

## Kelime Gruplarının Anlamı
Kelime grupları bazen tek kelime gibi anlam kazanır.
**Örnekler**: 
- "Gözü açık" = uyanık, dikkatli
- "Ayağı kaymak" = hata yapmak
- "Kulağına küpe olsun" = iyice akılda tutsun

## Deyim ve Atasözlerinin Anlamı
Deyim ve atasözleri mecazi anlam taşır, parça parça çevrilmez.`,
    keyPoints: [
      'Düz anlam doğrudan anlaşılan anlamdır',
      'Mecaz anlam kapalı, dolaylı anlamdır',
      'Kelime grupları yeni anlamlar kazanabilir',
      'Deyimlerin anlamı kelimelerinin toplamından farklıdır',
      'Bağlam cümlenin anlamını etkiler'
    ],
    examples: [
      'Düz: Bardağı kırdı. (Gerçekten kırıldı)',
      'Mecaz: Kalbini kırdı. (Üzdü)',
      'Deyim: Burnunun ucunu görmez. (Çok kibirli)',
      'Atasözü: Damlaya damlaya göl olur. (Küçük şeyler birleşir)'
    ],
    difficulty: 'medium',
    estimatedReadTime: 7,
    tags: ['cümle', 'anlam', 'mecaz', 'deyim', 'atasözü'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-003',
    title: 'Parçada Anlam',
    subject: 'turkce',
    topic: 'Anlam Bilgisi',
    content: `# Parçada Anlam

## Ana Düşünce
Metnin tamamında işlenen asıl konudur. Genellikle bir cümle ile özetlenir.
- Metin boyunca vurgulanır
- Paragrafların hepsinde iz bırakır
- Yazarın asıl vermek istediği mesajdır

## Yardımcı Düşünceler
Ana düşünceyi destekleyen, açıklayan düşüncelerdir.
- Örnekler verirler
- Kanıtlar sunarlar
- Ayrıntıları belirtirler

## Anahtar Kelimeler
Metnin anlamını belirleyen önemli kelimelerdir.
- Sık tekrar edilir
- Konuyla doğrudan ilgilidir
- Metnin ana temasını yansıtır

## Çıkarım Yapma
Metinde doğrudan söylenmeyip anlaşılan bilgilerdir.
- Satır aralarını okuma
- İpuçlarından sonuç çıkarma
- Yazarın ima ettiği anlamları bulma

## Metindeki Duygular
Yazarın metinde hissettirdiği duygulardır.
**Örnekler**: Sevinç, üzüntü, öfke, hayranlık, eleştiri`,
    keyPoints: [
      'Ana düşünce metnin temel mesajıdır',
      'Yardımcı düşünceler ana düşünceyi destekler',
      'Anahtar kelimeler konuyu belirler',
      'Çıkarım yapabilme önemli bir beceridir',
      'Metinlerde duygular da analiz edilmelidir'
    ],
    examples: [
      'Ana düşünce: "Kitap okumak faydalıdır"',
      'Yardımcı düşünce: "Kelime hazinesi gelişir"',
      'Anahtar kelime: "eğitim, öğrenme, bilgi"',
      'Çıkarım: Okur-yazar olmayan toplumlar geri kalır'
    ],
    difficulty: 'medium',
    estimatedReadTime: 8,
    tags: ['parça', 'ana düşünce', 'çıkarım', 'anahtar kelime'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-004',
    title: 'Parçada Anlatım',
    subject: 'turkce',
    topic: 'Anlatım Biçimleri',
    content: `# Parçada Anlatım

## Öyküleyici Anlatım
Olayları, yaşanmışlıkları anlatan anlatım biçimidir.
- **Zaman**: Geçmiş zaman kullanılır
- **Kişiler**: Olay kahramanları vardır
- **Mekan**: Olayın geçtiği yer belirtilir
- **Örnekler**: Hikaye, roman, anı

## Betimleyici Anlatım
Varlıkları, durumları ayrıntılı bir şekilde anlatan biçimdir.
- **Amaç**: Canlandırma, tasvir etme
- **Özellik**: Beş duyu organına hitap eder
- **Zaman**: Şimdiki zaman kullanılır
- **Örnekler**: Manzara, portre betimlemeleri

## Açıklayıcı Anlatım
Bir konuyu bilgilendirmek, öğretmek amacıyla kullanılır.
- **Amaç**: Bilgi verme, öğretme
- **Dil**: Yalın, anlaşılır
- **Örnekler**: Ders kitapları, ansiklopedi

## Tartışmacı Anlatım
Bir konuda görüş belirtme, ikna etme amacıyla kullanılır.
- **Amaç**: İkna etme, görüş bildirme
- **Özellik**: Kanıt, örnek sunar
- **Örnekler**: Köşe yazıları, münazaralar`,
    keyPoints: [
      'Öyküleyici anlatım olay odaklıdır',
      'Betimleyici anlatım ayrıntılı tasvir yapar',
      'Açıklayıcı anlatım bilgi verir',
      'Tartışmacı anlatım ikna etmeyi amaçlar',
      'Her anlatım biçiminin kendine özgü özellikleri vardır'
    ],
    examples: [
      'Öyküleyici: "Bir gün ormanda yürürken..."',
      'Betimleyici: "Çınarın yaprakları sararmış, dalları..."',
      'Açıklayıcı: "Fotosintez, bitkilerin ışık enerjisini..."',
      'Tartışmacı: "Kitap okumak şarttır çünkü..."'
    ],
    difficulty: 'medium',
    estimatedReadTime: 7,
    tags: ['anlatım', 'öyküleyici', 'betimleyici', 'açıklayıcı', 'tartışmacı'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-005',
    title: 'Parçada Yapı',
    subject: 'turkce',
    topic: 'Metin Yapısı',
    content: `# Parçada Yapı

## Giriş
Metnin başlangıç kısmıdır. Konuya hazırlık yapar.
- Konuyu tanıtır
- Okuyucunun ilgisini çeker
- Konu hakkında genel bilgi verir
- Genellikle birinci paragraftır

## Gelişme
Metnin asıl konusunun işlendiği bölümdür.
- En geniş kısımdır
- Ana düşünce burada işlenir
- Ayrıntılar, örnekler verilir
- Birden fazla paragraftan oluşur

## Sonuç
Metnin bitiş kısmıdır. Konuyu özetler.
- Varılan sonucu belirtir
- Tavsiyelerde bulunur
- Genel bir değerlendirme yapar
- Genellikle son paragraftır

## Paragraf Yapısı
Her paragrafın kendi iç yapısı vardır:
- **Anahtar cümle**: Paragrafın ana düşüncesi
- **Yardımcı cümleler**: Ana düşünceyi destekler
- **Bağlayıcılar**: Cümleler arası geçişi sağlar

## Bağlayıcı İfadeler
Metinde anlam bütünlüğünü sağlayan kelime ve kelime gruplarıdır.
**Örnekler**: ancak, fakat, çünkü, bu nedenle, sonuç olarak`,
    keyPoints: [
      'Her metnin giriş-gelişme-sonuç yapısı vardır',
      'Giriş konuya hazırlık yapar',
      'Gelişme bölümü en detaylı kısımdır',
      'Sonuç bölümü özet ve değerlendirme içerir',
      'Bağlayıcılar anlam bütünlüğü sağlar'
    ],
    examples: [
      'Giriş: "Günümüzde teknoloji..."',
      'Gelişme: "Bu durumun nedenleri şunlardır..."',
      'Sonuç: "Sonuç olarak görülüyor ki..."',
      'Bağlayıcı: "Öte yandan, ayrıca, böylece"'
    ],
    difficulty: 'medium',
    estimatedReadTime: 8,
    tags: ['yapı', 'giriş', 'gelişme', 'sonuç', 'paragraf', 'bağlayıcı'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-006',
    title: 'Sözel Mantık',
    subject: 'turkce',
    topic: 'Mantık ve Akıl Yürütme',
    content: `# Sözel Mantık

## Neden-Sonuç İlişkisi
Olaylar arasındaki sebep-sonuç bağını kurmadır.
- **Neden**: Olayın sebebi, kaynağı
- **Sonuç**: Nedenin doğurduğu durum
- **Bağlaçlar**: çünkü, bu yüzden, bu nedenle, dolayısıyla

## Benzerlik-Karşıtlık
İki durum arasındaki benzer veya farklı yönleri bulmadır.
- **Benzerlik**: gibi, benzer şekilde, aynı biçimde
- **Karşıtlık**: ama, fakat, ancak, oysa, buna karşın

## Amaç-Sonuç
Yapılan işin amacı ile elde edilen sonuç arasındaki ilişkidir.
- **Amaç bağlaçları**: için, amacıyla, maksadıyla
- **Sonuç bağlaçları**: böylece, sonuçta, neticesinde

## Varsayım-Koşul
Bir durumun gerçekleşmesi için gerekli şartları belirtir.
- **Koşul bağlaçları**: eğer, şayet, koşuluyla
- **Varsayım**: olasılık belirten ifadeler

## Genelleme-Örnekleme
Genel kuraldan özel duruma veya özel durumdan genel kurala gitme.
- **Genelleme**: bütün, her, tümü
- **Örnekleme**: örneğin, mesela, şöyle ki`,
    keyPoints: [
      'Neden-sonuç ilişkisi sebep-etki bağıdır',
      'Benzerlik ve karşıtlık karşılaştırma yapar',
      'Amaç-sonuç hedef odaklı düşüncedir',
      'Varsayım-koşul şartlı durumları belirtir',
      'Genelleme-örnekleme genel-özel ilişkisidir'
    ],
    examples: [
      'Neden-sonuç: Yağmur yağdığı için sokaklar ıslak.',
      'Karşıtlık: Çalışkan ama başarısız.',
      'Amaç: Sağlıklı olmak için spor yapıyor.',
      'Koşul: Eğer çalışırsan başarılı olursun.',
      'Örnekleme: Meyveler, örneğin elma, armut...'
    ],
    difficulty: 'hard',
    estimatedReadTime: 9,
    tags: ['mantık', 'neden', 'sonuç', 'karşıtlık', 'koşul', 'genelleme'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-007',
    title: 'Tablo, Grafik ve Görsel Yorumlama',
    subject: 'turkce',
    topic: 'Görsel Okuma',
    content: `# Tablo, Grafik ve Görsel Yorumlama

## Tablo Okuma
Tablolarda bilgiler satır ve sütunlarda düzenlenir.
- **Başlık**: Tablonun konusunu belirtir
- **Satırlar**: Yatay bilgi dizileri
- **Sütunlar**: Dikey bilgi dizileri
- **Veri**: Kesişim noktalarındaki bilgiler

## Grafik Türleri
### Sütun Grafiği
- Dikey çubuklarla veri gösterir
- Karşılaştırma yapmaya uygun
- Kategorik veriler için kullanılır

### Çizgi Grafiği
- Zaman içindeki değişimi gösterir
- Trend analizi için uygun
- Sürekli veriler için kullanılır

### Pasta Grafiği
- Bütünün parçalarını gösterir
- Yüzdelik dağılım için uygun
- Toplam %100 olmalıdır

## Fotoğraf ve Resim Yorumlama
- **Kompozisyon**: Öğelerin düzeni
- **Renk kullanımı**: Duygusal etki
- **Perspektif**: Bakış açısı
- **Semboller**: Gizli anlamlar

## Harita Okuma
- **Lejant**: Sembollerin anlamları
- **Ölçek**: Uzaklık hesaplama
- **Yönler**: Pusula, koordinat`,
    keyPoints: [
      'Tablolar düzenli veri sunumu yapar',
      'Her grafik türünün kendine özgü kullanım alanı vardır',
      'Görsellerde sembolik anlamlar aranmalıdır',
      'Haritalar coğrafi bilgileri görselleştirir',
      'Görsel okuma becerisi bilgi edinme aracıdır'
    ],
    examples: [
      'Tablo: Nüfus istatistikleri, not çizelgesi',
      'Sütun grafiği: Şehirlerin nüfus karşılaştırması',
      'Çizgi grafiği: Sıcaklık değişimi',
      'Pasta grafiği: Bütçe dağılımı'
    ],
    difficulty: 'medium',
    estimatedReadTime: 8,
    tags: ['tablo', 'grafik', 'görsel', 'yorumlama', 'harita'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-008',
    title: 'Yazım Kuralları',
    subject: 'turkce',
    topic: 'İmla',
    content: `# Yazım Kuralları

## Büyük Harf Kullanımı
### Cümle Başı
- Her cümlenin ilk harfi büyük yazılır
- Noktalı virgül (;) den sonra küçük harfle devam edilir

### Özel İsimler
- Kişi adları: Mehmet, Ayşe, Fatma
- Yer adları: Ankara, İstanbul, Türkiye
- Kitap, dergi adları: Nutuk, Milliyet
- Marka adları: Mercedes, Samsung

### Unvanlar ve Saygı İfadeleri
- Türkiye Cumhurbaşkanı
- Türkiye Büyük Millet Meclisi
- Hz. Muhammed, Hz. Ali

## Küçük Harf Kullanımı
- Cins isimler: masa, kitap, okul
- Meslek adları: öğretmen, doktor, mühendis
- Gün ve ay adları: pazartesi, ocak, mayıs

## Kesme İşareti (')
### Özel İsimlerde
- Türkiye'nin, Ankara'dan, Mehmet'in

### Yabancı Sözcüklerde
- Lozan'da, New York'ta, Paris'ten

## Birleşik Yazılış
- Birleşik fiiller: gözgöze, başbaşa
- Birleşik isimler: anaokulu, ortaokul
- Pekiştirme: tertemiz, mosmor`,
    keyPoints: [
      'Özel isimler büyük harfle başlar',
      'Cümle başları büyük harfle yazılır',
      'Cins isimler küçük harfle yazılır',
      'Kesme işareti özel isimlerde kullanılır',
      'Birleşik sözcükler bitişik yazılır'
    ],
    examples: [
      'Özel isim: Türkiye, Ankara, Mehmet',
      'Cins isim: ülke, şehir, insan',
      'Kesme: Türkiye\'nin, Ali\'nin',
      'Birleşik: anaokul, başöğretmen'
    ],
    difficulty: 'easy',
    estimatedReadTime: 7,
    tags: ['yazım', 'büyük harf', 'küçük harf', 'kesme', 'birleşik'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-009',
    title: 'Noktalama İşaretleri',
    subject: 'turkce',
    topic: 'İmla',
    content: `# Noktalama İşaretleri

## Nokta (.)
- Cümle sonunda kullanılır
- Kısaltmalarda kullanılır: Dr., Prof.
- Sıra sayılarında: 1. sınıf, 3. kat

## Virgül (,)
- Cümle öğelerini ayırır
- Sıralanan kelimeleri ayırır: kalem, defter, silgi
- Seslenme eki sonrasında: Ahmet, gel buraya.

## Noktalı Virgül (;)
- Uzun cümleleri ayırır
- Sıralanan uzun öbeklerı ayırır
- Madde madde sıralamada

## Soru İşareti (?)
- Soru cümlelerinde
- Şüphe belirten cümlelerde

## Ünlem İşareti (!)
- Ünlem cümlelerinde
- Emir cümlelerinde: Çabuk gel!
- Güçlü duyguları belirtmede

## İki Nokta (:)
- Açıklama yapmadan önce
- Örnekler vermeden önce
- Söz aktarmadan önce

## Tire (-)
- Kelime bölümünde
- Karşılıklı konuşmada
- Birleşik sayılarda: yirmi-bir

## Tırnak İşareti (" ")
- Doğrudan alıntılarda
- Özel anlamda kullanılan sözcüklerde
- Kitap, makale adlarında`,
    keyPoints: [
      'Her noktalama işaretinin özel kullanım yeri vardır',
      'Nokta cümleyi bitirir',
      'Virgül cümle öğelerini ayırır',
      'Soru işareti soru cümlelerinde kullanılır',
      'Tırnak işareti alıntılarda kullanılır'
    ],
    examples: [
      'Nokta: Okula gitti.',
      'Virgül: Ali, Veli ve Ayşe geldi.',
      'Soru işareti: Ne yapıyorsun?',
      'Ünlem: Ne güzel!',
      'Tırnak: "Merhaba" dedi.'
    ],
    difficulty: 'easy',
    estimatedReadTime: 8,
    tags: ['noktalama', 'nokta', 'virgül', 'soru işareti', 'tırnak'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-010',
    title: 'Metin Türleri',
    subject: 'turkce',
    topic: 'Metin Bilgisi',
    content: `# Metin Türleri

## Bilgilendirici Metinler
### Makale
- Bilimsel konuları ele alır
- Objektif dil kullanır
- Kanıt ve örnekler sunar

### Rapor
- Belirli bir konuda bilgi verir
- Sistematik yapıya sahiptir
- Resmi dil kullanır

### Haber Metni
- Güncel olayları bildirir
- 5N1K kuralına uyar
- Objektif ve yalın dil

## Öyküleyici Metinler
### Hikaye
- Kısa öykü türüdür
- Az sayıda karakter
- Tek olay ekseninde gelişir

### Roman
- Uzun öykü türüdür
- Çok sayıda karakter
- Birden fazla olay

### Anı
- Yaşanmış olayları anlatır
- Birinci şahıs anlatım
- Öznel bakış açısı

## Şiir
- Duygu ve düşünceleri dize halinde sunar
- Ölçü, uyak, ritim kullanır
- Söz sanatları içerir

## Tiyatro
- Sahnelenme amacıyla yazılır
- Diyalog halinde
- Perde, sahne, dekor`,
    keyPoints: [
      'Her metin türünün kendine özgü özellikleri vardır',
      'Bilgilendirici metinler objektif dil kullanır',
      'Öyküleyici metinler olay anlatır',
      'Şiirde dil sanatları ön plandadır',
      'Tiyatro sahnelenme amacıyla yazılır'
    ],
    examples: [
      'Makale: Bilimsel araştırma yazıları',
      'Haber: Gazetedeki güncel haberler',
      'Hikaye: "Kaşağı" - Ömer Seyfettin',
      'Roman: "Çalıkuşu" - Reşat Nuri',
      'Şiir: "İstiklal Marşı" - Mehmet Akif'
    ],
    difficulty: 'medium',
    estimatedReadTime: 9,
    tags: ['metin türleri', 'makale', 'hikaye', 'roman', 'şiir', 'tiyatro'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-011',
    title: 'Söz Sanatları',
    subject: 'turkce',
    topic: 'Edebi Sanatlar',
    content: `# Söz Sanatları

- Teşbih (Benzetme): Benzerlik ilgisiyle iki varlığı karşılaştırma. Benzeyen, kendisine benzetilen, benzetme yönü, benzetme edatı.
- Mecaz-ı Mürsel (Ad Aktarması): İlişkili olduğu başka bir ad yerine kullanma (parça-bütün, yer-eser).
- Teşhis (Kişileştirme): İnsan dışı varlıklara insan özelliği verme.
- İntak (Konuşturma): İnsan dışı varlıklara konuşturma.
- Mübalağa (Abartma): Bir durumu olduğundan çok/az gösterme.
- Kinaye: Hem gerçek hem mecaz anlama gelebilecek kullanım.
- Tenasüp: Anlamca birbiriyle ilgili kelimeleri birlikte kullanma.`,
    keyPoints: [
      'Benzetmede dört öğe bulunabilir',
      'Ad aktarması ilişki temellidir',
      'Teşhis ve intak sıkça birlikte görülür',
      'Mübalağa abartı içerir',
      'Kinayede gerçek ve mecaz anlam birlikte çağrışır'
    ],
    examples: [
      'Aslan gibi delikanlı (teşbih)',
      'Okulu kazandı ("okul"=üniversite, mecaz-ı mürsel)',
      'Rüzgar fısıldadı (teşhis/intak)'
    ],
    difficulty: 'medium',
    estimatedReadTime: 8,
    tags: ['edebi sanat', 'mecaz', 'teşbih', 'kinaye'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-012',
    title: 'Fiilimsiler',
    subject: 'turkce',
    topic: 'Sözcük Bilgisi',
    content: `# Fiilimsiler

- İsim-Fiil (Mastar): -ma/-me, -ış/-iş, -mak/-mek ekleri; fiili adlaştırır (yazmak, gülme).
- Sıfat-Fiil (Ortaç): -an/-en, -ası/-esi, -r/-ar/-er, -dik/-dık, -ecek/-acak; fiili sıfat yapar (okuyan çocuk).
- Zarf-Fiil (Bağ-Fiil): -ken, -ince, -ip, -meden/-madan, -dikçe; fiili zarf yapar (gelince, gülmeden).
- Fiilimsi cümle öğesi olarak ad, sıfat ya da zarf görevi üstlenir.`,
    keyPoints: [
      'İsim-fiiller ad, sıfat-fiiller niteleyici görev üstlenir',
      'Zarf-fiiller yan cümlecik kurar',
      'Fiilimsiler yüklem olmaz, kip eki almaz'
    ],
    examples: [
      'Okumak faydalıdır (isim-fiil)',
      'Gelen öğrenci (sıfat-fiil)',
      'Gülmeden konuştu (zarf-fiil)'
    ],
    difficulty: 'medium',
    estimatedReadTime: 7,
    tags: ['fiilimsi', 'mastar', 'ortaç', 'bağ-fiil'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-013',
    title: 'Cümlenin Öğeleri',
    subject: 'turkce',
    topic: 'Cümle Bilgisi',
    content: `# Cümlenin Öğeleri

- Yüklem: Cümlenin temel ögesi, yargıyı bildirir.
- Özne: Yüklemin bildirdiği işi yapan/olan.
- Nesne: Yüklemden etkilenen (belirtili/belirtisiz).
- Dolaylı Tümleç (Yer Tamlayıcısı): -e/-de/-den ekli tümleç.
- Zarf Tümleci: Zaman, durum, yer-yön, miktar, sebep, amaç bildiren öge.
- Edat/Öbek Tümleci: Edatla kurulan tümleçler.
- Ögeleri bulmada yüklemden sorularla gidilir.`,
    keyPoints: [
      'Öge bulmada önce yüklem bulunmalı',
      'Özne kim/ne sorusuyla bulunur',
      'Nesne neyi/neyi sorularıyla bulunur',
      'Dolaylı tümleç -e/-de/-den ekleriyle anlaşılır',
      'Zarf tümleci nasıl/ne zaman/niçin sorularını cevaplar'
    ],
    examples: [
      'Ayşe (özne) kitabı (nesne) hızlıca (zarf t.) okudu (yüklem).'
    ],
    difficulty: 'easy',
    estimatedReadTime: 7,
    tags: ['özne', 'yüklem', 'nesne', 'tümleç'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-014',
    title: 'Fiilde Çatı',
    subject: 'turkce',
    topic: 'Cümle Bilgisi',
    content: `# Fiilde Çatı

- Etken: Özne bellidir ve işi yapar (Ali geldi).
- Edilgen: İş özne tarafından yapılmaz, -l/-n (Kapı açıldı).
- Dönüşlü: İş özneye döner, -l/-n (Yıkandı).
- İşteş: İş birlikte yapılır, -ş (Konuştu, dövüştü).
- Geçişli/Geçişsiz: Nesne alıp almamasına göre.
- Ettirgen: Fiile -t/-tır ekleri ile başkasına yaptırma (Yazdırdı).`,
    keyPoints: [
      'Çatı ekleri fiilin aldığı eklerle anlaşılır',
      'Geçişlilik nesne ile test edilir',
      'Ettirgen fiiller başkasına yaptırmayı ifade eder'
    ],
    examples: [
      'Kapı açıldı (edilgen)',
      'Çocuk giyindi (dönüşlü)',
      'Konuştular (işteş)'
    ],
    difficulty: 'medium',
    estimatedReadTime: 7,
    tags: ['çatı', 'etken', 'edilgen', 'işteş', 'dönüşlü'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-015',
    title: 'Cümle Türleri',
    subject: 'turkce',
    topic: 'Cümle Bilgisi',
    content: `# Cümle Türleri

- Yüklemin Türüne Göre: İsim cümlesi (yargı adla), fiil cümlesi (yargı fiille).
- Anlamına Göre: Olumlu/olumsuz, soru, ünlem, emir, şart.
- Yapısına Göre: Basit (tek yargı), birleşik (yan cümlecik var), sıralı (bağlaçla/bağlaçsız), bağlı (bağlaçla bağlanan).
- Yüklemin Yerine Göre: Kurallı (yüklem sonda), devrik (yüklem sonda değil), eksiltili.`,
    keyPoints: [
      'Basit cümlede tek yargı bulunur',
      'Birleşik cümlede yan cümlecik vardır',
      'Sıralı ve bağlı cümlede birden fazla yargı bulunur'
    ],
    examples: [
      'Okula gitti (fiil c.)',
      'Hava çok güzel (isim c.)',
      'Erken kalkarsa başarılı olur (birleşik)'
    ],
    difficulty: 'easy',
    estimatedReadTime: 6,
    tags: ['cümle türleri', 'basit', 'birleşik', 'sıralı', 'bağlı'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-016',
    title: 'Anlatım Bozuklukları',
    subject: 'turkce',
    topic: 'Cümle Bilgisi',
    content: `# Anlatım Bozuklukları

- Anlam Bakımından: Gereksiz sözcük, mantık hatası, yanlış anlam ilişkisi, anlatım belirsizliği.
- Yapı Bakımından: Özne-yüklem uyuşmazlığı, eksik/yanlış tümleç, tümleç-yüklem uyumsuzluğu, çatı uyuşmazlığı.
- Deyim ve atasözlerini yanlış kullanma, eklerin yanlış/eksik kullanımı bozukluğa yol açar.`,
    keyPoints: [
      'Özne-yüklem uyumu temel kontroldür',
      'Gereksiz sözcüklerden kaçınılmalıdır',
      'Anlam belirsizliği bağlama göre giderilir'
    ],
    examples: [
      'Onu geçen hafta dün gördüm (zaman çelişkisi)',
      'Kitapları sever ve okurdu (yüklem uyumsuzluğu)'
    ],
    difficulty: 'hard',
    estimatedReadTime: 8,
    tags: ['anlatım bozukluğu', 'uyum', 'mantık'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  },
  {
    id: 'tr-017',
    title: 'Deyim ve Atasözleri',
    subject: 'turkce',
    topic: 'Söz Varlığı',
    content: `# Deyim ve Atasözleri

- Deyim: Genellikle mecaz anlamlı kalıplaşmış sözlerdir (göz ardı etmek).
- Atasözü: Deneyimlerle süzülmüş öğüt verici kalıplaşmış sözlerdir (Damlaya damlaya göl olur).
- Deyimler çekimlenebilir; atasözleri genel doğrular bildirir, öğüt içerir.
- Yorumda kelimeleri tek tek değil, bütün olarak anlamlandırmak gerekir.`,
    keyPoints: [
      'Deyimler kalıplaşmıştır ve mecazlıdır',
      'Atasözleri genelleme ve öğüt içerir',
      'Deyimler cümlede çekimlenebilir'
    ],
    examples: [
      'Burnundan solumak (çok öfkelenmek)',
      'İşleyen demir ışıldar (çalışmanın önemi)'
    ],
    difficulty: 'easy',
    estimatedReadTime: 6,
    tags: ['deyim', 'atasözü', 'mecaz'],
    color: '#EF4444',
    isPublished: true,
    viewCount: 0,
    likeCount: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    createdBy: 'admin'
  }
];